export class getControllerById {
    deviceId:number;
    Bat_Volts:number;
    chargingCurrent: string;
    solarVoltage: string;
    mode: string;
    daily: string;
    monthly: string;
    percent: string;
    Lat: string;
    Lon: string;
    ID;
    }